<template>
<div class="widgetPanel sportsMenu special" :class="{'collapsed': oddSelected}" style="margin-bottom: auto!important; cursor: pointer; background: transparent;"  v-if="showGameBanner || showImageBanner">
  <div class="glyphIcon icon-widgetCollapse" title="Collapse the Widget Panel"></div>
  <div id="euro_menu_all">
      <div id="euro_banner" class="euro_btn" @click.prevent="selectGameBanner()" :style="{'cursor':(showImageBanner?'default':'pointer')}" v-if="!(openBetForm && position == 'l')">
        <template v-if="position == 'mini'">
          <!--img :src="gameBannerImage.imgIco" style="content: ''; display: inline-block; background-repeat: no-repeat; background-size: cover; width: 24px; height: 24px;"-->
          <span class="q-icon icon c-icon sport-img icon" style="width: 22px;height: 22px;" :style="{ backgroundImage: 'url(' + gameBannerImage.imgIco + ')' }"></span>
        </template>
        <template v-else>
          <template v-if="cookies_lang == 'zh_TW'">
            <img :src="gameBannerImage['imgList_tw' + (position == 't'? '':'_l')]" :style="position == 't'? 'width: 395px;':'width: 220px;'">
          </template>
          <template v-else-if="cookies_lang == 'zh_CN'">
            <img :src="gameBannerImage['imgList_cn' + (position == 't'? '':'_l')]" :style="position == 't'? 'width: 395px;':'width: 220px;'">
          </template>
          <template v-else-if="cookies_lang == 'th_TH'">
            <img :src="gameBannerImage['imgList_th' + (position == 't'? '':'_l')]" :style="position == 't'? 'width: 395px;':'width: 220px;'">
          </template>
          <template v-else-if="cookies_lang == 'vn_VN'">
            <img :src="gameBannerImage['imgList_vn' + (position == 't'? '':'_l')]" :style="position == 't'? 'width: 395px;':'width: 220px;'">
          </template>
          <template v-else-if="cookies_lang == 'id_ID'">
            <img :src="gameBannerImage['imgList_id' + (position == 't'? '':'_l')]" :style="position == 't'? 'width: 395px;':'width: 220px;'">
          </template>
          <template v-else-if="cookies_lang == 'pt_PT'">
            <img :src="gameBannerImage['imgList_pt' + (position == 't'? '':'_l')]" :style="position == 't'? 'width: 395px;':'width: 220px;'">
          </template>
          <template v-else-if="cookies_lang == 'es_MX'">
            <img :src="gameBannerImage['imgList_sp' + (position == 't'? '':'_l')]" :style="position == 't'? 'width: 395px;':'width: 220px;'">
          </template>
          <template v-else>
            <img :src="gameBannerImage['imgList_en' + (position == 't'? '':'_l')]" :style="position == 't'? 'width: 395px;':'width: 220px;'">
          </template>
        </template>
        <!-- <template v-if="cookies_lang == 'zh_TW'">
          <img :src="gameBannerImage.imgList_tw" style="width: 395px;" v-if="position == 't'">
          <img :src="gameBannerImage.imgList_tw_l" style="width: 220px;" v-else-if="position == 'l'">
          <img :src="gameBannerImage.imgIco" style="content: ''; display: inline-block; background-repeat: no-repeat; background-size: cover; width: 24px; height: 24px; background-color: white;" v-else="position == 'mini'">
        </template>
        <template v-else-if="cookies_lang == 'zh_CN'">
          <img :src="gameBannerImage.imgList_cn" style="width: 395px;" v-if="position == 't'">
          <img :src="gameBannerImage.imgList_cn_l" style="width: 220px;" v-else-if="position == 'l'">
          <img :src="gameBannerImage.imgIco" style="content: ''; display: inline-block; background-repeat: no-repeat; background-size: cover; width: 24px; height: 24px; background-color: white;" v-else="position == 'mini'">
        </template>
        <template v-else-if="cookies_lang == 'th_TH'">
          <img :src="gameBannerImage.imgList_th" style="width: 395px;" v-if="position == 't'">
          <img :src="gameBannerImage.imgList_th_l" style="width: 220px;" v-else-if="position == 'l'">
          <img :src="gameBannerImage.imgIco" style="content: ''; display: inline-block; background-repeat: no-repeat; background-size: cover; width: 24px; height: 24px; background-color: white;" v-else="position == 'mini'">
        </template>
        <template v-else-if="cookies_lang == 'vn_VN'">
          <img :src="gameBannerImage.imgList_vn" style="width: 395px;" v-if="position == 't'">
          <img :src="gameBannerImage.imgList_vn_l" style="width: 220px;" v-else-if="position == 'l'">
          <img :src="gameBannerImage.imgIco" style="content: ''; display: inline-block; background-repeat: no-repeat; background-size: cover; width: 24px; height: 24px; background-color: white;" v-else="position == 'mini'">
        </template>
        <template v-else-if="cookies_lang == 'id_ID'">
          <img :src="gameBannerImage.imgList_id" style="width: 395px;" v-if="position == 't'">
          <img :src="gameBannerImage.imgList_id_l" style="width: 220px;" v-else-if="position == 'l'">
          <img :src="gameBannerImage.imgIco" style="content: ''; display: inline-block; background-repeat: no-repeat; background-size: cover; width: 24px; height: 24px; background-color: white;" v-else="position == 'mini'">
        </template>
        <template v-else-if="cookies_lang == 'pt_PT'">
          <img :src="gameBannerImage.imgList_pt" style="width: 395px;" v-if="position == 't'">
          <img :src="gameBannerImage.imgList_pt_l" style="width: 220px;" v-else-if="position == 'l'">
          <img :src="gameBannerImage.imgIco" style="content: ''; display: inline-block; background-repeat: no-repeat; background-size: cover; width: 24px; height: 24px; background-color: white;" v-else="position == 'mini'">
        </template>
        <template v-else-if="cookies_lang == 'es_MX'">
          <img :src="gameBannerImage.imgList_sp" style="width: 395px;" v-if="position == 't'">
          <img :src="gameBannerImage.imgList_sp_l" style="width: 220px;" v-else-if="position == 'l'">
          <img :src="gameBannerImage.imgIco" style="content: ''; display: inline-block; background-repeat: no-repeat; background-size: cover; width: 24px; height: 24px; background-color: white;" v-else="position == 'mini'">
        </template>
        <template v-else>
          <img :src="gameBannerImage.imgList_en" style="width: 395px;" v-if="position == 't'">
          <img :src="gameBannerImage.imgList_en_l" style="width: 220px;" v-else-if="position == 'l'">
          <img :src="gameBannerImage.imgIco" style="content: ''; display: inline-block; background-repeat: no-repeat; background-size: cover; width: 24px; height: 24px; background-color: white;" v-else="position == 'mini'">
        </template> -->
      </div>
      <div class="contentArea" v-if="false">
          <div class="nav-widgetPanel icon-sportsMenu-today threeColum">
              <div class="item icon-sportsMenu-early" :class="{'early_on': selectedMarket == market.earlyMarket.key && isGameBannerSelected , 'early': selectedMarket != market.earlyMarket.key && isGameBannerSelected, 'active': selectedMarket == market.earlyMarket.key && isGameBannerSelected}" id="earlyBtn">
                  <span class="itemContent" :title="langList.GAME_BANNER['GAME_BANNER.EARLY']">
                      <span class="text"  @click="gameMarket(market.earlyMarket.key)">
                          {{ langList.GAME_BANNER['GAME_BANNER.EARLY'] }}
                      </span>
                      <div class="alertArea" v-if="earlyCount>0">
                          <div class="alert">{{ earlyCount }}</div>
                      </div>
                  </span>
              </div>
              <div class="item icon-sportsMenu-today" :class="{'today_on': selectedMarket == market.tdyMarket.key && isGameBannerSelected, 'today': selectedMarket != market.tdyMarket.key && isGameBannerSelected , 'active': selectedMarket == market.tdyMarket.key && isGameBannerSelected}" id="todayBtn">
                  <span class="itemContent" :title="langList.GAME_BANNER['GAME_BANNER.TODAY']">
                      <span class="text"  @click="gameMarket(market.tdyMarket.key)">
                        {{ langList.GAME_BANNER['GAME_BANNER.TODAY'] }}
                      </span>
                      <div class="alertArea"  v-if="tdyCount>0">
                          <div class="alert">{{ tdyCount }}</div>
                      </div>
                  </span>
              </div>
              <div class="item  icon-sportsMenu-live" :class="{'rb_on': selectedMarket == market.inPlayMarket.key && isGameBannerSelected, 'rb': selectedMarket != market.inPlayMarket.key && isGameBannerSelected , 'active': selectedMarket == market.inPlayMarket.key && isGameBannerSelected}"  id="rbBtn">
                  <span class="itemContent" :title="langList.GAME_BANNER['GAME_BANNER.IN_PLAY']">
                      <span class="text" @click="gameMarket(market.inPlayMarket.key)">
                          {{ langList.GAME_BANNER['GAME_BANNER.IN_PLAY'] }}
                      </span>
                      <div class="alertArea"  v-if="inPlyCount>0">
                          <div class="alert">{{ inPlyCount }}</div>
                      </div>
                  </span>
              </div>
          </div>
      </div>
      <!--div class="event_btn">
          <div class="opt_btn" :class="{'selected' : selectedMarket == market.earlyMarket.key && isGameBannerSelected}" @click="gameMarket(market.earlyMarket.key)">
              <span class="title">{{ langList.GAME_BANNER['GAME_BANNER.EARLY'] }} ({{ earlyCount }})</span>
          </div>
          <div class="opt_btn" :class="{'selected' : selectedMarket == market.tdyMarket.key && isGameBannerSelected}" @click="gameMarket(market.tdyMarket.key)">
              <span class="title">{{ langList.GAME_BANNER['GAME_BANNER.TODAY'] }} ({{ tdyCount }})</span>
          </div>
          <div class="opt_btn" :class="{'selected' : selectedMarket == market.inPlayMarket.key && isGameBannerSelected}" @click="gameMarket(market.inPlayMarket.key)">
              <span class="title">{{ langList.GAME_BANNER['GAME_BANNER.IN_PLAY'] }} ({{ inPlyCount }})</span>
          </div>
      </div-->
  </div>
</div>
</template>
<script>
import { mapGetters } from "vuex";
import sportMatchCount from '@/vue/mixins/sportMatchCount'
import EventBus from '@/vue/events/event-bus'

export default {
  mixins: [ sportMatchCount ],
  computed: {
    ...mapGetters(["oddSelected", "selectedTab", "langList", "isGameBannerSelected", "market", "selectedMarket", "openBetForm"]),
    sportList () {
      return _.keyBy(this.$store.getters.sportList, 'sprtId')
    }
  },
  props:{
    position: null,
  },
  data () {
      return {
        timer1: 60,
        timerId1: null,
        timer2: 180,
        timerId2: null,
        timer3: 180,
        timerId3: null,
        tdyCount: 0,
        earlyCount: 0,
        inPlyCount: 0,
        showGameBanner: false,
        showImageBanner: false,
        gameBannerImage: window._gameBannerImage,
        cookies_lang: window._cookie,
        isClicked: false,
      }
    },
  methods: {
    startTimer(market) {
      if (this['timerId'+market] == null) {
        this['timerId'+market] = setInterval(() => {
          if(this.isGameBannerSelected){
            if (this['timer'+market] - 1 < 0) {
              this.getMatches(market);
            } else {
              this['timer'+market] -= 1;
            }
          } else {
            this.clearTimer(market);
          }
        }, 1000);
      }
    },
    clearTimer(market) {
      market = market.toString()
      clearInterval(this['timerId'+market]);
      this['timerId'+market] = null;
    },
    reinitTimer(market) {
      var timer = 0
      // if(this.market.inPlayMarket.key == market) {
      //   timer = 60
      // } else if (this.market.tdyMarket.key == market) {
      //   timer = 180
      // } else if (this.market.earlyMarket.key == market) {
      //   timer = 180
      // }
      timer = 60

      this['timer'+market] = timer;
      this.startTimer(market);
    },
    getGameBannerCount(market, count) {
      if(this.market.inPlayMarket.key == market) {
        this.inPlyCount = count
      } else if (this.market.tdyMarket.key == market) {
        this.tdyCount = count
      } else if (this.market.earlyMarket.key == market) {
        this.earlyCount = count
      }
    },
    getMatches(market) {
      market = market.toString()
      this.clearTimer(market);
      this.$store.dispatch("getSportEventList", {
        market: market,
        isGameBanner: true,
        callback: (res => {
          if(res.totalMatch) {
            if(res.totalMatch[this.market.inPlayMarket.key]) {
              this.getGameBannerCount(this.market.inPlayMarket.key, res.totalMatch[this.market.inPlayMarket.key][this.sportList.N1.sprtId.slice(1)])
            }else {
              this.getGameBannerCount(this.market.inPlayMarket.key, 0)
            }
            if(res.totalMatch[this.market.tdyMarket.key]) {
              this.getGameBannerCount(this.market.tdyMarket.key, res.totalMatch[this.market.tdyMarket.key][this.sportList.N1.sprtId.slice(1)])
            }else {
              this.getGameBannerCount(this.market.tdyMarket.key, 0)
            }
            if(res.totalMatch[this.market.earlyMarket.key]) {
              this.getGameBannerCount(this.market.earlyMarket.key, res.totalMatch[this.market.earlyMarket.key][this.sportList.N1.sprtId.slice(1)])
            }else {
              this.getGameBannerCount(this.market.earlyMarket.key, 0)
            }
            if(this.isClicked){
              if(this.inPlyCount > 0){
                this.$store.commit('SELECTED_MARKET', this.market.tdyMarket.key)
                market = this.market.tdyMarket.key
              }else{
                if(this.tdyCount > 0){
                  this.$store.commit('SELECTED_MARKET', this.market.tdyMarket.key)
                  market = this.market.tdyMarket.key
                }else{
                  if(this.earlyCount > 0){
                    this.$store.commit('SELECTED_MARKET', this.market.earlyMarket.key)
                    market = this.market.earlyMarket.key
                  }
                }
              }
              this.isClicked = false
              this.$store.commit('SELECTED_MARKET', market)
              EventBus.$emit('refreshOdd', true );
              EventBus.$emit('marketChange', market);
            }
          } else {
            // if no matches set to 0
            this.getGameBannerCount(this.market.inPlayMarket.key, 0)
            this.getGameBannerCount(this.market.tdyMarket.key, 0)
            this.getGameBannerCount(this.market.earlyMarket.key, 0)
            if(this.isClicked){
              this.isClicked = false
              this.$store.commit('SELECTED_MARKET', this.selectedMarket)
              EventBus.$emit('refreshOdd', true );
              EventBus.$emit('marketChange', this.selectedMarket);
            }
          }
          this.reinitTimer(market)
        }).bind(this)
      });
    },
    gameMarket(market) {
      EventBus.$emit('viewAccountSetting', false)
      this.$store.commit("GAMEBANNER_SELECTED", true);
      this.$store.commit('SELECTED_ALLBET', false)
      this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
      this.$store.commit('SELECTED_MARKET', market)
      this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
      this.$store.commit('SELECTED_SPORT', _.keyBy(this.$store.getters.sportList, 'sprtId')['N1'])
      this.resetSportBettype()
      this.$store.commit('SELECTED_BETTYPE',  _.cloneDeep(this.$store.getters.bettypeList[0]))
      EventBus.$emit('sportChange', this.$store.getters.selectedBettype );
      EventBus.$emit('marketChange', market );
      EventBus.$emit('refreshOdd', true );
    },
    selectGameBanner() {
      if(this.showGameBanner && !this.showImageBanner) {
        this.isClicked = true
        EventBus.$emit('viewAccountSetting', false)
        EventBus.$emit('changeShowOdds', false)
        this.$store.commit("SPECIAL_EVENT", false)
        this.$store.commit("HOT_SCHEDULE", false)
        this.$store.commit('SIMPLE_SPORT', null)
        this.$store.commit("GAMEBANNER_SELECTED", true);
        this.$store.commit('SELECTED_ALLBET', false)
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
        this.$store.commit('SELECTED_MATCHALLBET', false)
        this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
        this.$store.commit('OPEN_RBMARKET', false)
        this.$store.commit('LIVE_SCHECULE', false)
        this.$store.commit('EVENTLIST', [])
        this.$store.commit('SORTEDEVENTLIST', [])
        this.$store.commit('SORTEDRBEVENTLIST', [])
        var market = this.$store.getters.market.tdyMarket.key
        if(this.$store.getters.selectedMarket == '2'){
          market = this.$store.getters.market.earlyMarket.key
          this.$store.commit('RBEVENTLIST', [])
          this.$store.dispatch('getEarlyEventCountByDate');
        }
        this.$store.commit('SELECTED_MARKET', market)
        this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[0])
        this.resetSportBettype()
        // EventBus.$emit('refreshOdd', true );
        // EventBus.$emit('marketChange', market);
        // this.$store.dispatch('getSportEventList', {
        //     token: token.arr_2,
        //     isGameBanner: true,
        // })
        this.getMatches([1,2,3]);
      }
    },
  },
  beforeMount() {
    if(window._gameBanner) {
      this.showGameBanner = true
      this.$store.commit('GAME_BANNER_ID', window._gameBanner)
      // this.$store.commit('GAME_BANNER_SPORT_ID', this.$store.getters.sportList[0].sprtId)
      this.$store.commit('GAME_BANNER_SPORT_ID', 'N1')
      // this.getMatches(1);
      // this.getMatches(2);
      // this.getMatches(3);
      this.getMatches([1,2,3]);
    } else if(window._imageBanner) {
      var def_pos = window._gameBannerImage.position? window._gameBannerImage.position:['l','t']
      if(def_pos.includes(this.position)) {
        this.showImageBanner = true
      }
    }
    EventBus.$off('selectGameBanner');
    EventBus.$on('selectGameBanner', ()=> {
      this.selectGameBanner();
    })
  },
  destroyed() {
    this.clearTimer([1,2,3]);
    EventBus.$off('selectGameBanner');
  }
};
</script>
<style lang="scss">
@import "~@/styles/base/global";
@import "~@/styles/home/contentsLeft/gameBanner";
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/home/contentsLeft/gameBanner.vue